import BaseAPI from "./base/base-api";

class AssetTypeAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "AssetType";
}

export default new AssetTypeAPI();
